import {createRouter, createMemoryHistory, createWebHistory, createWebHashHistory} from 'vue-router'
import routes from './routes.js'
import {Notify} from 'quasar'
import {useAuthStore} from 'src/stores/AuthStore.js'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */


const createHistory = process.env.SERVER
  ? createMemoryHistory
  : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory)

const Router = createRouter({
  scrollBehavior: () => ({left: 0, top: 0}),
  routes,

  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
})

Router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  if (to.name === "VersionError") return next()

  //****************************************************************
  //*** Check if new Version available - so reload browser cache ***
  //****************************************************************
  if (authStore.sessionToken) {
    let tokendata = JSON.parse(atob(authStore.sessionToken.split('.')[1]))

    console.log("APP Versioncheck. Backend: ", tokendata.newestFrontendVersion, ", Frontend: ", PP_CONST.APP_VERSION)

    if (tokendata.newestFrontendVersion !== PP_CONST.APP_VERSION) {
      //next()
      if (localStorage.getItem("retry_reload_router")) {
        localStorage.removeItem("retry_reload_router")
        console.error("tried reload, but version still differs: ", tokendata.newestFrontendVersion, "!=", PP_CONST.APP_VERSION)
        return next({name: "VersionError"})

      } else {
        console.error("APP Version (", PP_CONST.APP_VERSION, ") does not match with server version (", tokendata.newestFrontendVersion, ")")
        localStorage.setItem("retry_reload_router", "1")
        console.log("post to ", window.location.href)
        window.location.reload()
      }
    } else {
      if (localStorage.getItem("retry_reload_router")) {
        Notify.create({
          icon: 'info',
          progress: true,
          color: 'blue',
          textColor: 'white',
          message: "Aktualisierung v" + tokendata.newestFrontendVersion + " installiert."
        })
        localStorage.removeItem("retry_reload_router")
      }
    }
    if (tokendata.portalServerVersion) {
      authStore.portalServerVersion = tokendata.portalServerVersion
    }
  }

  if (from.query.pageAfterBack) {
    to.query.page = from.query.pageAfterBack
  }
  if (from.query.pageAppAfterBack) {
    to.query.pageApp = from.query.pageAppAfterBack
  }

  // for Deep Link call, check given request parameters
  // supported:
  //   k (key) - key value of record to be selected in query result
  //   kf - select first record automatically
  //   qry.<paramname> - parameter for query call (auto filled in Parameter.vue)
  if (to.query.k) {
    console.log("router.beforeEach query parameter default query or app mode left:", to.query.k)
    authStore.queryKeyFromDeepLink = to.query.k
  }

  if (to.query.frmwl) {
    console.log("Formlist to process:", to.query.fl)
    authStore.formularWhiteList = to.query.frmwl
  }

  if (to.query.ak) {
    console.log("router.beforeEach query parameter app mode right:", to.query.ak)
    authStore.queryAppKeyFromDeepLink = to.query.ak
  }

  if (to.query.kf !== undefined) {
    console.warn("router.beforeEach key select first:", to.query.kf)
    authStore.queryKeySelectFirstRow = true
  }

  if (from.query.deleteAction === 1) {
    delete to.query.aac
    delete to.query.ac
    delete to.query.deleteAction
    authStore.queryActionNativeNameFromDeepLink = null
    authStore.queryAppActionNativeNameFromDeepLink = null
  } else {
    if (to.query.ac) {
      console.log("router.beforeEach query parameter default query or app mode left:", to.query.ac)
      authStore.queryActionNativeNameFromDeepLink = to.query.ac
    }

    if (to.query.aac) {
      console.log("router.beforeEach query parameter app mode right:", to.query.aac)
      authStore.queryAppActionNativeNameFromDeepLink = to.query.aac
    }
  }

  if (to.query.sid) {
    console.log("router.beforeEach sid parameter:", to.query.sid)
    // do session validate!!!
    // todo: ...
    //authStore.sessionID = to.query.sid
  }

  if (to.query.gst === "1") {
    //let lsLogin = localStorage.getItem("storedRefreshToken")
    console.log("Autologin as guest parameter active", to.query.gst === "1")
    authStore.autoLoginAsGuest = true
  }

  if (to.query.nparam === "1") {
    console.log("Prevent Parameter input", to.query.nparam === "1")
    authStore.preventParameterInput = true
  }

  if (to.query.ctxt) {
    console.log("router.beforeEach query parameter:", to.query.ctxt)
    authStore.queryActionCxtParamFromDeepLink = to.query.ctxt
  }

  if (to.query.qpor) {
    authStore.queryParamOverridePermanent = true
    console.log("permanent override of deep link parameters enabled")
  }

  if (!authStore.queryParamOverridePermanent) {
    authStore.queryParamListFromDeepLink = []
  }

  Object.keys(to.query)
    .filter(param => {
      return param.indexOf("qp.") === 0
    })
    .forEach(param => {
      authStore.queryParamListFromDeepLink[param.substring(3)] = to.query[param]
    })
/*

  // Deeplink-Parameter einmalig verarbeiten, dann aus URL entfernen
  const deepLinkParams = ['k', 'ak', 'kf', 'ac', 'aac', 'sid', 'gst', 'nparam', 'ctxt', 'frmwl', 'qpor']
  const hasDeepLinkParams = deepLinkParams.some(p => to.query[p] !== undefined)
    || Object.keys(to.query).some(p => p.startsWith('qp.'))

  if (hasDeepLinkParams && !authStore.deepLinkProcessed) {
    authStore.deepLinkProcessed = true

    // Query-Parameter ohne Deeplink-Params für replace vorbereiten
    const cleanQuery = {...to.query}
    deepLinkParams.forEach(p => delete cleanQuery[p])

    // Auch qp.* Parameter entfernen wenn nicht permanent
    if (!authStore.queryParamOverridePermanent) {
      Object.keys(cleanQuery)
        .filter(p => p.startsWith('qp.'))
        .forEach(p => delete cleanQuery[p])
    }

    console.log("Deeplink parameters processed and removed from URL")
    next({...to, query: cleanQuery, replace: true})
    return
  }
*/


  next()
})

export default Router

